import VendorIcon from './ic_vendor_reward.svg';

export { VendorIcon };
